import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "space-y-3"
}

import { ChevronRight } from 'lucide-vue-next';
    import { Button } from '@/components/ui/button';
    import {
        Dialog,
        DialogTrigger,
        DialogContent,
        DialogHeader,
        DialogTitle,
        DialogDescription,
        DialogClose,
        DialogFooter,
        DialogBody,
    } from '@/components/ui/dialog';
    import { Alert } from '@/components/ui/alert';
    import { Checkbox } from '@/components/ui/checkbox';
    import { computed, ref } from 'vue';
    import { Label } from '@/components/ui/label';
    import { toast } from 'vue-sonner';
    import { useI18n } from 'vue-i18n';
    import { useMutation } from '@tanstack/vue-query';
    import { useQueryClient } from '@tanstack/vue-query';
    import axios from 'axios';
    import QueryKey from '@/enums/QueryKey';
    import type { Voucher } from '@/types';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ApproveVoucher',
  props: {
    voucher: {}
  },
  setup(__props: any) {

    const queryClient = useQueryClient();

    const props = __props;

    const { t } = useI18n();

    const acceptAgreement = ref(false);
    const isOpen = ref(false);

    const isOverLimit = computed(() => {
        const currentSum = props.voucher.no_voucher ? Math.abs(props.voucher.Amount) : 0;

        if (!props.voucher.voucher_limit) return false;

        return currentSum > props.voucher.voucher_limit;
    });

    const { mutate, isPending } = useMutation({
        mutationFn: (formData: { id: number }) =>
            axios.post(route('v2.voucher.upload.specific'), formData),
        onSuccess: (data) => {
            queryClient.invalidateQueries({
                queryKey: [QueryKey.VOUCHERS, props.voucher.company_id],
            });

            isOpen.value = false;
            toast.success(data.data.success);
        },
        onError: (error: any) => {
            isOpen.value = false;
            toast.error(error.response.data.message || t('forms.system_error'));
        },
    });

    function approve() {
        mutate({
            id: props.voucher.id,
        });
    }

    function handleCancel() {
        isOpen.value = false;
        acceptAgreement.value = false;
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    open: isOpen.value,
    "onUpdate:open": _cache[1] || (_cache[1] = ($event: any) => ((isOpen).value = $event))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(DialogTrigger), { "as-child": "" }, {
        default: _withCtx(() => [
          _createVNode(_unref(Button), {
            variant: "accent",
            size: "xs"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('forms.approve')) + " ", 1),
              _createVNode(_unref(ChevronRight))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(DialogContent), { class: "sm:max-w-lg" }, {
        default: _withCtx(() => [
          _createVNode(_unref(DialogHeader), null, {
            default: _withCtx(() => [
              _createVNode(_unref(DialogTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('vouchers.js.approve_title')) + " " + _toDisplayString(_ctx.voucher.Text), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(DialogBody), { class: "space-y-5" }, {
            default: _withCtx(() => [
              _createVNode(_unref(DialogDescription), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('vouchers.js.approve_content')), 1)
                ]),
                _: 1
              }),
              (isOverLimit.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(_unref(Alert), { variant: "warning" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('vouchers.js.limit_amount')) + " " + _toDisplayString(_ctx.voucher.voucher_limit), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Label), {
                      for: "acceptAgreement",
                      class: "flex cursor-pointer items-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Checkbox), {
                          modelValue: acceptAgreement.value,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((acceptAgreement).value = $event)),
                          id: "acceptAgreement"
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('vouchers.js.limit_agreement')), 1)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_unref(DialogFooter), { class: "gap-2 border-t sm:justify-center" }, {
            default: _withCtx(() => [
              _createVNode(_unref(DialogClose), { "as-child": "" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Button), {
                    variant: "outline",
                    size: "sm",
                    onClick: handleCancel
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('forms.cancel')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(Button), {
                disabled: _unref(isPending) || (isOverLimit.value && !acceptAgreement.value),
                loading: _unref(isPending),
                size: "sm",
                onClick: approve
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('forms.yes')), 1)
                ]),
                _: 1
              }, 8, ["disabled", "loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})